'use strict';
import { Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {EndlessScrollingUtil} from '../nddUtils/endlessScollingUtil.service';
const he = require('he');

@Component({
    directives: [],
    "selector": "prm-copy-clipboard-btn",
    templateUrl: 'components/clipboard/copy-clipboard-btn.html'
})



export class PrmCopyClipboardBtn implements OnInit{

    @Input() public text: string;
    @Input() private action: string;

    private buttonText;
    private offset: number;
    private DISPLAY_TEXT: string;
    private SAFARI_DISPLAY_TEXT: string;
    private COPIED_TEXT: string;
    private SAFARI_COPIED_TEXT: string;
    private FAILURE_TEXT: string;
    private scrollContainer: HTMLElement;
    private copySuccessful = false;


    constructor(@Inject('$timeout') private $timeout : ng.ITimeoutService,
                @Inject('clipboard') private clipboard,
                private endlessScrollingUtil: EndlessScrollingUtil){
        this.scrollContainer= this.getScrollContainer() as HTMLElement;
    }

     ngOnInit(){
         this.DISPLAY_TEXT = 'nui.' + this.action + '.button';
         this.SAFARI_DISPLAY_TEXT= this.getSelectButtonText();
         this.COPIED_TEXT = 'nui.' + this.action + '.message.success';
         this.SAFARI_COPIED_TEXT= 'nui.' + this.action + '.copy.message';
         this.FAILURE_TEXT = 'nui.' + this.action + '.message.failed';
         this.buttonText = this.isSupported? this.DISPLAY_TEXT: this.SAFARI_DISPLAY_TEXT;
    }

    clipboardSuccess(){
        this.displayTemporaryText(this.isSupported? this.COPIED_TEXT : this.SAFARI_COPIED_TEXT);
        this.copySuccessful = true;
        this.scrollContainer.scrollTop= this.offset;
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    clipboardFailure(err) {
        this.displayTemporaryText(this.FAILURE_TEXT);
        console.error("Clipborad error!", err);
        this.scrollContainer.scrollTop= this.offset;
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    private displayTemporaryText(txt){
        this.buttonText = txt;
        this.$timeout(() => {
            this.buttonText = this.isSupported? this.DISPLAY_TEXT: this.SAFARI_DISPLAY_TEXT;
            this.copySuccessful = false;
            this.setFocusOnElement();
        }, 4000);
    }
    
    private setFocusOnElement(){
        let selector = (this.action == 'permalink') ? '#Permalink button' : '#Citation button';
        let element = document.querySelector(selector) as HTMLElement;
        if(element){
            element.focus();
        }
    }

    private getSelectButtonText(){
        if(this.action == 'permalink'){
            return 'nui.permalink.button.selecturl';

        }//needs to be citation
        else {
            return 'citation.labels.selecttext';
        }

    }
    
    get textToCopy(){
        return he.decode(this.text ? String(this.text).replace(/<[^>]+>/gm, '') : '');
    }

    get isSupported(){
        let w = window as any;
        return !(Object.prototype.toString.call(w.HTMLElement).indexOf('Constructor') > 0); //return false if browse is safari
        //return this.clipboard.supported;
    }

    private saveOffset(){ //fixes defects PRM-29471 PRM-28752
        this.endlessScrollingUtil.disableSearchEndlessScrolling();
        this.offset= this.scrollContainer.scrollTop;
    }

    getScrollContainer(){
            let d = document as any;
            let isIE= false || !!d.documentMode;
            let w = window as any;
            //if chrome or safari or edge get document body
            if ((!!w.chrome && !!w.chrome.webstore) ||
                (Object.prototype.toString.call(w.HTMLElement).indexOf('Constructor') > 0) ||
                (!isIE && !!w.StyleMedia)){
                return document.body;
            }
            return document.body.parentNode;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/clipboard/copyClipboardBtn.directive.ts